import { Card } from "@/components/ui/card";

const reviews = [
  {
    quote: "My grades improved by 40% in just one semester",
    description: "I used to dread exam week. Now I go in feeling prepared. My grades went up 40% last semester.",
    name: "Emily Chen",
    title: "Grade 11",
    avatar1: "/images/avatars/review-1a.jpg",
    avatar2: "/images/logos/harvard.png",
  },
  {
    quote: "Now I understand concepts that confused me for years",
    description:
      "I failed chemistry twice. Shattara explained it differently and it finally clicked. Passed with an 87.",
    name: "Marcus Johnson",
    title: "College Student",
    avatar1: "/images/avatars/review-2a.jpg",
    avatar2: "/images/logos/stanford.png",
  },
  {
    quote: "We're delighted with how engaged our students are",
    description:
      "My students used to zone out. Since adding Shattara, they come to class with questions not blank stares!",
    name: "Sarah Williams",
    title: "Math Teacher, Riyadh",
    avatar1: "/images/avatars/review-3a.jpg",
    avatar2: "/images/logos/mit.png",
  },
  {
    quote: "The personalized learning paths were eye-opening",
    description: "Shattara AI has done an amazing job helping me prepare for exams, absolutely eye-opening!",
    name: "David Martinez",
    title: "University Student",
    avatar1: "/images/avatars/review-4a.jpg",
    avatar2: "/images/logos/oxford.png",
  },
];

export const Reviews = () => {
  // Duplicate reviews for seamless loop
  const duplicatedReviews = [...reviews, ...reviews, ...reviews];

  return (
    <section id="reviews" className="relative w-full py-20 px-4 md:px-10 bg-background overflow-hidden">
      <div className="container mx-auto max-w-[90rem]">
        {/* Header */}
        <div className="flex flex-col items-center justify-center mb-12">
          <h2 className="text-4xl md:text-6xl font-medium text-foreground leading-none text-center">
            Don't Take Our Word For It — Here's What <span className="text-primary">Students</span> Say
          </h2>
        </div>

        {/* Scrolling Reviews */}
        <div className="relative h-96 overflow-hidden">
          <div
            className="flex items-center"
            style={{
              maskImage:
                "linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 17.5%, rgb(0, 0, 0) 82.5%, rgba(0, 0, 0, 0) 100%)",
            }}
          >
            <div className="flex gap-6 animate-marquee-horizontal" style={{ animationDuration: "60s" }}>
              {duplicatedReviews.map((review, index) => (
                <Card
                  key={index}
                  className="flex-shrink-0 w-96 p-10 rounded-xl bg-card border-border hover:shadow-lg transition-shadow cursor-pointer"
                >
                  <div className="flex flex-col gap-5 h-full">
                    {/* Quote */}
                    <h3 className="text-3xl font-medium text-foreground leading-tight">"{review.quote}"</h3>

                    {/* Description */}
                    <p className="text-base text-muted-foreground">{review.description}</p>

                    {/* Author Info */}
                    <div className="flex items-center gap-4 mt-auto">
                      {/* University Logo + Person Avatar */}
                      <div className="relative flex items-center h-12">
                        <img
                          src={review.avatar2}
                          alt="University"
                          className="w-12 h-12 rounded-full object-contain bg-background border-2 border-background p-1.5"
                        />
                        <img
                          src={review.avatar1}
                          alt="Student"
                          className="w-12 h-12 rounded-full object-cover border-2 border-background -ml-4"
                        />
                      </div>

                      {/* Name and Title */}
                      <div className="flex flex-col gap-0.5">
                        <p className="text-foreground font-medium">{review.name}</p>
                        <p className="text-primary text-sm">{review.title}</p>
                      </div>
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
